import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores/Store';
import PreviewBrief from '../BriefPreview';
import './style.scss';
import { OutlinedButton, FilterRefined } from '../../../components';
import { Filter } from '../../../assets';
import { processProjectsData, processProfessionalsData, formatCash, processProjectsAndBriefs, fetchProsAndLeads } from '../../../utils/sharedFunctions';
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleWhiteLogo.svg`;
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`;
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`;
var mobile = require('is-mobile');
const defaultProjPlan = {
    projEndDate: new Date().toISOString().split('T')[0],
    projStartDate: new Date().toDateString().split('T')[0],
}
const Projects = observer(() => {
    const store = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [Projects, setProjects] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [ViewProject, setViewProject] = useState(false);
    const [SelectedProject, setSelectedProject] = useState({});
    const [Leads, setLeads] = useState([]);
    const [Professionals, setProfessionals] = useState([]);
    const [FilteredProjects, setFilteredProjects] = useState([]);
    const [isFilter, setIsFilter] = useState(false);
    const [isFilterCleared, setIsFilterCleared] = useState(true);
    const [FilterTerms, setFilterTerms] = useState([])
    const [AllUsers, setAllsers] = useState([]);
    useEffect(() => {
        getProjects();
    }, []);

    const getProjects = async () => {
        store.setLoading(true);
        try {
            const [projectsArr, rawBriefsArr, users, evaluation, quotesARR, projectPlans, vouchers] = await Promise.all([
                store.getProjects(),
                store.getBriefs(),
                store.getUsers(),
                store.getEvaluation(),
                store.getQuote(),
                store.getProjectPlans(),
                store.getVouchers(),
            ]);

            const validProjects = Array.isArray(projectsArr) ? projectsArr : [];
            const  unprocessedBriefs = Array.isArray(rawBriefsArr) ? rawBriefsArr : [];
            const validQuotes = Array.isArray(quotesARR) ? quotesARR : [];

            const prosAndLeads = await fetchProsAndLeads(users);

            const leads = prosAndLeads?.Leads ?? [];
            const professionals = prosAndLeads?.Pros ?? [];
            const clients = prosAndLeads.Clients ?? []
            const allUsers = leads.concat(professionals).concat(clients);

            const processedBriefs = processProjectsData(unprocessedBriefs, projectPlans, validProjects, evaluation, vouchers, validQuotes, prosAndLeads)
            const processProject_Brief = processProjectsAndBriefs(validProjects, processedBriefs, leads, evaluation, clients, projectPlans)

            const sortedProjects = processProject_Brief.processedProjects.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            const processedProfessionals = processProfessionalsData(professionals, processProject_Brief.processedProjects, processedBriefs);

            setLeads(leads);
            setProfessionals(processedProfessionals);
            setProjects(sortedProjects);
            setAllsers(allUsers ?? []);
            forceUpdate();
        } catch (error) {
            console.error(error);
        } finally {
            store.setLoading(false);
        }
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        forceUpdate();
    };
    const filteredProjects = (isFilterCleared ? Projects : FilteredProjects).filter(project => {
        const searchValue = searchTerm.toLowerCase();
        return (project.title.toLowerCase().includes(searchValue));
    });
    const getSelectedProject = (id) => {
        let projects = Projects;
        let selectedProject = projects.find(project => project._id === id);

        setSelectedProject(selectedProject);
        setViewProject(true);
        forceUpdate();
    };
    const backClicked = (e, isEdited) => {
        if (isEdited === true) {
            store.setLoading(true);
            getProjects();
        }
        setViewProject(false);
    };
    function handleFilterClick() {
        setIsFilter(true);
    };
    function closeFilterMouseleave() {
        setIsFilter(false);
    };
    function closeCardClck() {
        setIsFilterCleared(true);
        closeFilterMouseleave();
        setFilterTerms([]);
    };
    function getSearchTerm(searchTerms) {
        let terms = FilterTerms;
        processProjectsFiltration(terms, searchTerms)
    };
    function handleFilterChange(items) {
        // Initialize an array to hold the projects to be filtered
        let projectsArr = [];

        // If no filter items are provided, use all projects; otherwise, use the filtered projects
        if (items.length === 0) {
            projectsArr = [...Projects];
        } else {
            projectsArr = [...FilteredProjects];
            projectsArr = [...Projects];
        };

        // If there are filter items, proceed to filter the projects
        if (items.length > 0) {
            // Filter projects based on whether any of the filter items match specific project properties
            let filteredProjs = projectsArr.filter((project) =>
                items.some((item) =>
                    (Array.isArray(project.serviceCategory) && project.serviceCategory.includes(item)) || // Match service category
                    item === project.contractType || // Match contract type
                    item === project.projectPlan?.[0]?.fulfillmentStage || // Match fulfillment stage
                    item === project.briefStatus || // Match brief status
                    item === project._id || // Match project ID
                    item === (Number(new Date(project.createdAt).getMonth()) + 1) || // Match project creation month
                    item === project.client?.firstName || // Match client first name
                    item === project.client?.lastName || // Match client last name
                    item === project.client?.company || // Match client company
                    item === project.client?.email || // Match client email
                    item === project.fulfillmentLead?.firstName || // Match talent partner first name
                    item === project.fulfillmentLead?.lastName || // Match talent partner last name
                    item === project.fulfillmentLead?._id // Match talent partner ID
                )
            );

            // Filter projects further based on active lead filters
            const activeLeadFilters = items.filter(id => Leads.some(lead => lead._id === id));
            if (activeLeadFilters.length > 0) {
                filteredProjs = filteredProjs.filter(project => activeLeadFilters.includes(project.fulfillmentLead?._id));
            }

            // Update the state to reflect the filtered projects and active filter terms
            setIsFilterCleared(false);
            setFilteredProjects(filteredProjs);
            setFilterTerms([...items]);
        } else {
            // If no filter items are provided, reset to show all projects
            setFilteredProjects([...Projects]);
            setIsFilterCleared(true);
            closeCardClck(); // Clear the filter UI
        }
    }
    function processProjectsFiltration(terms, newTerm) {

        let updatedTerms = [...terms];
        if (!updatedTerms.includes(newTerm)) {
            updatedTerms.push(newTerm);
        }

        // Filter projects based on updated terms
        let filteredProjs = Projects.filter((project) => {

            return updatedTerms.every((term) =>
                (Array.isArray(project.serviceCategory) && project.serviceCategory.includes(term)) || // Treat serviceCategory as an array
                term === project.contractType ||
                term === project.projectPlan?.[0]?.fulfillmentStage ||
                term === project.briefStatus ||
                term === project._id ||
                term === (Number(new Date(project.createdAt).getMonth()) + 1) ||
                term === project.client?.firstName ||
                term === project.client?.lastName ||
                term === project.client?.company ||
                term === project.client?.email ||
                term === project.fulfillmentLead?.firstName ||
                term === project.fulfillmentLead?.lastName ||
                term === project.fulfillmentLead?._id
            );
        });
        // Update state with filtered projects and terms
        setIsFilterCleared(false);
        setFilteredProjects(filteredProjs);
        setFilterTerms(updatedTerms);
    };
    function processProjectsRemoval(terms) {
        let filteredProjs = [];

        Projects.forEach((project) => {
            if (terms.includes(project.serviceCategory) ||
                terms.includes(project.contractType) ||
                terms.includes(project.projectPlan[0].fulfillmentStage) ||
                terms.includes(project.briefStatus) ||
                terms.includes(project._id) ||
                terms.includes(Number(new Date(project.createdAt).getMonth()) + 1)
            ) {
                if (!filteredProjs.includes(project)) {
                    filteredProjs.push(project);
                }
            }
        });

        setIsFilterCleared(false);
        setFilteredProjects(filteredProjs);
        setFilterTerms(terms);
    };

    if (mobile()) {
        return (
            <div>

            </div>
        );

    } else {
        return (
            <div className='ProjectsContainer'>
                <div className='ProjectsContainerHeader'>
                    <p>Projects</p>
                    <img src={Credipple} alt='Credipple Logo' style={{ marginRight: '0.9%' }} />
                </div>
                <div className='ProjectsContainerBody'>
                    {(ViewProject) ?
                        <PreviewBrief project={SelectedProject} AllUsers={AllUsers} navigateMainToPage={(e, isEdited) => backClicked(e, isEdited)} professionals={Professionals} leads={Leads} />
                        :
                        <>
                            <div className='projectFilterSearch'>
                                <div className='SearchSection' style={{ width: '100%' }}>
                                    <div className='numofItems'>
                                        <p className='spancular'>{filteredProjects.length}</p>
                                    </div>
                                    <div className='filterSection' >
                                        <div onMouseEnter={handleFilterClick} className={FilterTerms.length === 0 ? 'filterContainer' : 'filterContainerAct'}>
                                            <span className='filterspan' >
                                                <img onMouseEnter={handleFilterClick} src={Filter} alt='' className='filterimg' />
                                            </span>
                                            {FilterTerms.length === 0 ? null :
                                                <p style={{ color: 'white', paddingLeft: '5%' }}>Filters({FilterTerms.length})</p>
                                            }
                                        </div>
                                    </div>
                                    {isFilter ?
                                        <FilterRefined Projects={Projects} Leads={Leads}
                                            getFilterTerm={getSearchTerm}
                                            terms={FilterTerms}
                                            handleFilterChange={handleFilterChange}
                                            CloseFilterML={closeFilterMouseleave} CloseCardClck={closeCardClck}
                                        />
                                        :
                                        null
                                    }
                                    <div className='search-bar-section' style={{ width: '25%', height: '50%' }}>
                                        <img src={SearchIcon} alt='Search Icon' />
                                        <input style={{ color: '#6D4194' }} placeholder='Search' value={searchTerm} onChange={handleSearchChange}></input>
                                    </div>
                                </div>
                            </div>
                            <div className='availableprojectsSection'>

                                {filteredProjects.length === 0 ? (
                                    <p className='noProjectsMessage'>No projects found</p>
                                ) : (
                                    filteredProjects.map((item, index) => {
                                        return (
                                            <div className='projectCard' key={index} onClick={() => getSelectedProject(item._id)}>
                                                <div className='viewprojectHeader'>
                                                    <p>{item.title || ''}</p>
                                                </div>
                                                <div className='viewProjectDetails'>
                                                    <div className='profileANdUserDetails'>
                                                        <div className='userProfile' >
                                                            <img src={UserIcon} style={{ width: '100%', height: '100%' }} />
                                                        </div>
                                                        <div className='userProfile-Details'>
                                                            {typeof item.client === 'object' ?
                                                                <>
                                                                    <p className='header' style={{ fontWeight: '700' }}>{item?.client ? `${item.client.firstName || ''} ${item.client.lastName || ''}` : ''}</p>
                                                                    <p className='value'>{item?.client?.email ? item.client.email.substring(0, 25) : item?.client?.website ? item.client.website.substring(0, 20) : ''}</p>

                                                                </>
                                                                :
                                                                <>
                                                                    <p className='header' style={{ fontWeight: '700' }}>Not Assigned</p>
                                                                    <p className='value'>Not Assigned</p>
                                                                </>
                                                            }

                                                        </div>
                                                    </div>
                                                    <div className='fulfillmentLeadDetails'>
                                                        <p className='header' style={{ fontWeight: '700' }}>Fulfillment Lead</p>
                                                        <p className='value'>{typeof item?.fulfillmentLead === 'object' ? `${item.fulfillmentLead.firstName || ''} ${item.fulfillmentLead.lastName || ''}` : 'Not Assigned'}</p>
                                                    </div>
                                                </div>
                                                <div className='viewDetailsContainer'>
                                                    <OutlinedButton className='detailsBtn'><p>View Details</p></OutlinedButton>
                                                </div>
                                            </div>
                                        )
                                    })
                                )}
                            </div>
                        </>}
                </div>
            </div>
        )
    }
})

export default Projects;